// Odkomentujte, pokud vám klient padá na chybu: AppContainer should be patched
//import {hot} from 'react-hot-loader';

import * as React from 'react';
console.log("Verze react", React.version);
import * as ReactDOM from 'react-dom';
console.log("Verze react-dom", ReactDOM.version);
import Root from './Root';
import {AppContainer} from 'react-hot-loader';
import store from './store/store'
import Raven from 'raven-js'

// Společná inicializace aplikace - polyfill apod.
import "mc/lib/commonInit";
import "mc/lib/toastr/toastr.less";
// import 'url-search-params-polyfill';

// Import css Bootstrapu
import 'font-awesome/css/font-awesome.css'
import 'marbes-iconfont/css/mif.less';
import './app-styles.scss';
import './app-styles-dark.scss';
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";

// if (!__DEV__) {
    // Logování
    // TODO berka po správné opravě digest ověřování lze vrátit zpět (nebo po umožnění anonymního logování na /api/log)
    // const {appVersion, buildNumber} = appConfig;

    // Raven.config(window.location.protocol + '//' + window.location.host + serverContextPath + '/log', {release: appVersion + (buildNumber ? buildNumber : '')}).install();
// }

const render = Component => {
    const MOUNT_POINT = document.getElementById('root');

    ReactDOM.render(
        <AppContainer>
            <Component store={store} />
        </AppContainer>,
        MOUNT_POINT
    )
};

render(Root);

if (module.hot) {
    module.hot.accept('./Root', () => render(Root));
}